import { render } from "./c_Contact.vue?vue&type=template&id=0063f59c"
import script from "./c_Contact.vue?vue&type=script&lang=js"
export * from "./c_Contact.vue?vue&type=script&lang=js"

import "../css/style.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__